import { get } from "../index";

export const getFeatureRequest = (id) => {
  return get(`/featureRequests/${id}`);
}; 
